<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_screen"></Header>
    <v-container fluid v-if="userMenu">
      <v-layout row wrap justify-center>
        <v-flex
          v-for="subMenu in userMenu.menu.submenu"
          :key="subMenu['@attributes'].txtid"
          xs12
          md6
          class="px-4 panel-block"
        >
          <sub-menu
            v-if="subMenu && userMenuData"
            :sub-menu="subMenu"
            :sub-menu-data="getParsedMenuData(subMenu)"
            :sub-menu-select-data="userMenu.menu.fieldsets.fieldset"
            :response-alert="setResponseAlert"
          ></sub-menu>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import SubMenu from "../components/SubMenu";
import GlobalService from "../services/global-service";

export default {
  components: {
    Header,
    SubMenu
  },
  data: () => ({
    userMenu: undefined,
    userMenuData: {},
    flashMessageData: {},
    pageRefreshTime: 30
  }),
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    async FetchApisData() {
      this.userMenu = await GlobalService.getMenu("screen", this.getUser.token);
      this.setSelectFieldValues();
      this.$store.commit("global/setLoading", false);
    },
    // to show the resposne alert on update field
    async setResponseAlert(resObj) {
      let SplitedScreenData = localStorage.getItem("screenValues").split(",");
      let index = await this.findScreenObjectIndex(
        SplitedScreenData,
        resObj,
        resObj.selection.split("")[0]
      );
      if (index >= 0) {
        SplitedScreenData[index + 1] = resObj.value;
      }
      localStorage.setItem("screenValues", SplitedScreenData.toString());
    },
    // find the specific Index from screenValues
    findScreenObjectIndex(ScreenData, data, str) {
      if (str == "b" && data.selection !== "") {
        let dhwIndex = data.selection.slice(6);
        return ScreenData.indexOf(str + dhwIndex);
      }
      if (str == "d" && data.selection !== "") {
        let dhwIndex = data.selection.slice(3);
        return ScreenData.indexOf(str + dhwIndex);
      }
      if (str == "h" && data.selection !== "") {
        let dhwIndex = data.selection.slice(6);
        return ScreenData.indexOf(str + dhwIndex);
      }
      if (str == "w" && data.selection !== "") {
        let dhwIndex = data.selection.slice(7);
        return ScreenData.indexOf(str + dhwIndex);
      }
    },
    setSelectFieldValues() {
      this.userMenu.menu.fieldsets.fieldset.forEach(element => {
        for (let i = 0; i < element.field.length; i++) {
          element.field[i]["@attributes"].value =
            element.field[i]["@attributes"].id;
        }
      });
    },
    getParsedMenuData(userMenu) {
      let SplitedScreenData = localStorage.getItem("screenValues").split(",");

      for (let i = 0; i < userMenu.field.length; i++) {
        let fieldudp = userMenu.field[i]["@attributes"].udp.split("");
        let parsedudp =
          fieldudp[0] +
          `${
            userMenu.field.length === i + 1 && fieldudp[0] !== "w"
              ? fieldudp[fieldudp.length - 2]
              : ""
          }` +
          fieldudp[fieldudp.length - 1];
        let dataIndex = SplitedScreenData.findIndex(e => e === parsedudp);
        if (dataIndex >= 0) {
          this.userMenuData[userMenu.field[i]["@attributes"].udp] = {
            factor: 1,
            max: -1,
            min: -1,
            val: SplitedScreenData[dataIndex + 1]
          };
        }
      }

      return this.userMenuData;
    }
  }
};
</script>
